import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { of } from 'rxjs';

import {
  CreateNotificationContentFormAction,
  NotificationContentFormCreatedAction,
  NotificationContentFormErroredAction,
  NotificationContentFormLoadAction,
  NotificationContentFormLoadErroredAction,
  NotificationContentFormLoadSucceededAction,
  NotificationContentFormUpdatedAction,
  UpdateNotificationContentFormAction,
} from './notification-content-form.actions';
import { NotificationContentService } from '../notification-content/notification-content.service';
import { NotificationContentFormApiError, NotificationContentFormApiErrorTypes } from './types';
import { SnackBarEffectCreatorService } from '../../shared/services/effect-creators/snackbar-effect-creator.service';

@Injectable()
export class NotificationContentFormEffects {
  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateNotificationContentFormAction),
      mergeMap(({ notificationContent }) =>
        this.notificationContentService.create(notificationContent).pipe(
          map((entity) => {
            this.router.navigate(['/admin/notifications']);

            return NotificationContentFormCreatedAction({ notificationContent: entity });
          }),
          catchError((err) => {
            const error = new NotificationContentFormApiError(
              NotificationContentFormApiErrorTypes.ServiceUnavailableError,
              err,
            );
            return of(NotificationContentFormErroredAction({ error }));
          }),
        ),
      ),
    ),
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateNotificationContentFormAction),
      mergeMap(({ id, notificationContent }) =>
        this.notificationContentService.update(id, notificationContent).pipe(
          map((entity) => NotificationContentFormUpdatedAction({ notificationContent: entity })),
          catchError((err) => {
            const error = new NotificationContentFormApiError(
              NotificationContentFormApiErrorTypes.ServiceUnavailableError,
              err,
            );
            return of(NotificationContentFormErroredAction({ error }));
          }),
        ),
      ),
    ),
  );

  getById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationContentFormLoadAction),
      mergeMap(({ notificationContentId }) =>
        this.notificationContentService.getById(notificationContentId).pipe(
          map((notificationContent) =>
            NotificationContentFormLoadSucceededAction({ notificationContent }),
          ),
          catchError((err) => {
            const error = new NotificationContentFormApiError(
              NotificationContentFormApiErrorTypes.ServiceUnavailableError,
              err,
            );
            return of(NotificationContentFormLoadErroredAction({ error }));
          }),
        ),
      ),
    ),
  );

  notificationContentUpdatedSuccessfullySnackbar$ = this.snackBarEffectCreatorService.createEffect({
    initiatingAction: NotificationContentFormUpdatedAction,
    message: () => 'Notification content successfully updated',
  });

  constructor(
    protected actions$: Actions,
    protected notificationContentService: NotificationContentService,
    private router: Router,
    private snackBarEffectCreatorService: SnackBarEffectCreatorService,
  ) {}
}
